import React from "react";
import L from "leaflet";
import { Circle, Polygon } from "react-leaflet";
import { v4 as uuidv4 } from "uuid";
const circleToPolygon = require("circle-to-polygon");

const GeoZonePropertyCode = {
  geometryType: 0,
  perimeter: 1,
  area: 2,
  radius: 3,
  centerPoint: 4,
  color: 5,
  changeColor: 6,
  ifInside: 7,
  insideAll: 8,
  opacity: 9,
  isGeometryChanged: 10,
};

export function getPropertyСonstant(propertiy) {
  switch (propertiy.code) {
    case GeoZonePropertyCode.geometryType:
      return {
        title: "Тип",
        value: propertiy.value === "circle" ? "Окружность" : "Область",
      };
    case GeoZonePropertyCode.perimeter:
      return {
        title: "Периметр",
        value: propertiy.value + " км",
      };
    case GeoZonePropertyCode.area:
      return {
        title: "Площадь",
        value: propertiy.value + " км²",
      };
    case GeoZonePropertyCode.centerPoint:
      return {
        title: "Центр",
        value: propertiy.value,
      };
    case GeoZonePropertyCode.radius:
      return {
        title: "Радиус",
        value: propertiy.value + " км",
      };
    default:
      return null;
  }
}

function сircle(layer) {
  const radius = Math.round((layer._mRadius / 1000 + Number.EPSILON) * 1000) / 1000;
  const area = (Math.PI * Math.round(radius * 1000 * (radius * 1000))) / 1000;
  const perimeter = 2 * Math.PI * radius;

  const geometry = JSON.stringify(circleToPolygon([layer._latlng.lng, layer._latlng.lat], radius * 1000, 1024));

  const properties = [
    {
      code: GeoZonePropertyCode.geometryType,
      value: "circle",
    },
    {
      code: GeoZonePropertyCode.radius,
      value: radius + "",
    },
    {
      code: GeoZonePropertyCode.area,
      value: Math.round(area * 1000) / 1000 + "",
    },
    {
      code: GeoZonePropertyCode.perimeter,
      value: Math.round(perimeter * 1000) / 1000 + "",
    },
    {
      code: GeoZonePropertyCode.centerPoint,
      value: JSON.stringify([Math.round(layer._latlng.lng * 100000) / 100000, Math.round(layer._latlng.lat * 100000) / 100000]),
    },
  ];

  return {
    properties,
    geometry,
  };
}

function polygon(layer) {
  const geoJsonGeometry = {
    type: "Polygon",
    coordinates: [],
  };

  geoJsonGeometry.coordinates.push(
    layer._latlngs[0].map((item) => {
      return [item.lng, item.lat];
    })
  );

  geoJsonGeometry.coordinates[0].push(geoJsonGeometry.coordinates[0][0]);
  const geometry = JSON.stringify(geoJsonGeometry);

  let perimeter = 0;
  for (let i = 1; i < layer._latlngs[0].length; i++) {
    perimeter += layer._latlngs[0][i - 1].distanceTo(layer._latlngs[0][i]);
  }

  perimeter += layer._latlngs[0][layer._latlngs[0].length - 1].distanceTo(layer._latlngs[0][0]);
  const properties = [
    {
      code: GeoZonePropertyCode.geometryType,
      value: "polygon",
    },
    {
      code: GeoZonePropertyCode.area,
      value: Math.round(L.GeometryUtil.geodesicArea(layer.getLatLngs()[0])) / 1000 + "",
    },
    {
      code: GeoZonePropertyCode.perimeter,
      value: Math.round(perimeter) / 1000 + "",
    },
  ];

  return {
    properties,
    geometry,
  };
}

export function createGeozone(layer) {
  const feature = layer._mRadius ? сircle(layer) : polygon(layer);

  return {
    id: null,
    title: null,
    geometry: feature.geometry,
    properties: feature.properties,
    units: [],
  };
}

function circleDOMElement(geozone, onSelectGeozone, onSetMapBounds) {
  const radius = geozone.properties.filter((property) => {
    return property.code === GeoZonePropertyCode.radius;
  })[0];

  const center = JSON.parse(
    geozone.properties.filter((property) => {
      return property.code === GeoZonePropertyCode.centerPoint;
    })[0].value
  );

  return (
    <Circle
      key={uuidv4()}
      id={geozone.id}
      title={geozone.title}
      center={[center[1], center[0]]}
      radius={Number(radius.value * 1000)}
      eventHandlers={{
        click: () => {
          setMapBoudns(JSON.parse(geozone.geometry), onSetMapBounds);
          onSelectGeozone(geozone);
        },
      }}
    />
  );
}

function setMapBoudns(geoJson, onSetMapBounds) {
  const latLngs = geoJson.coordinates[0].map((item) => {
    return L.latLng(item[1], item[0]);
  });

  onSetMapBounds(new L.latLngBounds(latLngs));
}

function polygonDOMElement(geozone, onSelectGeozone, onSetMapBounds) {
  const geoJson = JSON.parse(geozone.geometry);

  geoJson.coordinates.slice(geoJson.coordinates.length - 1, 1);

  const latLangs = [];
  latLangs.push(
    geoJson.coordinates[0].map((item) => {
      const LatLng = new L.LatLng(item[1], item[0]);
      return LatLng;
    })
  );

  return (
    <Polygon
      key={uuidv4()}
      id={geozone.id}
      geozone={geozone}
      positions={latLangs}
      eventHandlers={{
        click: (e) => {
          setMapBoudns(geoJson, onSetMapBounds);
          onSelectGeozone(e.target.options.geozone);
        },
      }}
    />
  );
}

export function getGeozonesByUnit(geozones, carId = null) {
  return geozones
    .map((geozone) => {
      if (carId) {
        if (geozone.units.some((x) => x.id === carId)) {
          return geozone;
        }

        return null;
      }

      return geozone;
    })
    .filter((x) => {
      return x !== null;
    });
}

export function getGeozones(geozones, onSelectGeozone, onSetMapBounds, carId = null) {
  return geozones.map((geozone) => {
    if (carId) {
      if (geozone.units.some((x) => x.id === carId)) {
        return getCircleOrPolygon(geozone, onSelectGeozone, onSetMapBounds);
      }

      return null;
    }

    return getCircleOrPolygon(geozone, onSelectGeozone, onSetMapBounds);
  });
}

export function getCircleOrPolygon(geozone, onSelectGeozone, onSetMapBounds) {
  return geozone.properties.some((property) => {
    return property.code === GeoZonePropertyCode.centerPoint;
  })
    ? circleDOMElement(geozone, onSelectGeozone, onSetMapBounds)
    : polygonDOMElement(geozone, onSelectGeozone, onSetMapBounds);
}
